@if (isSms && previewMessageVisible) {
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="sms-instructions">
    {{ 'COMMUNICATIONS.DESIGNER.GO-TO-NOTIFICATION-SETTINGS' | translate }}
  </div>
}
<div class="designer"
  [ngStyle]="{ 'width': width }"
  [ngClass]="{ 'is-sms': isSms, 'is-slack': isSlack, 'is-whatsapp': isWhatsApp }"
  (dragenter)="dragenterElement($event)"
  (dragover)="dragoverElement($event)"
  (drop)="dropElement(-1, $event)">
  <div class="body">
    <!-- Slack Header -->
    @if (showSlackHeader) {
      <div
        class="slack-header mb-4"
        fxLayout="row"
        fxLayoutAlign="start center">
        <div>
          <img class="slack-avatar"
            src="/assets/images/crisis24-logo.svg" />
        </div>
        <div>
          <div fxLayout="row"
            fxLayoutAlign="start center">
            <div class="slack-username">TopoONE by Crisis24</div>
            <div class="slack-app">APP</div>
            <div class="slack-date">10:24 AM</div>
          </div>
          @if (headerDatasetName) {
            <div class="slack-type"
              >
              <span class="slack-dataset-type">{{ headerDatasetType }}</span>
              @if (headerDatasetType && headerDatasetName) {
                <span>|</span>
              }
              {{ headerDatasetName }}
            </div>
          }
          @if (headerDatasetName) {
            <div
              class="slack-name"
            [innerHTML]="headerDocumentName"></div>
          }
        </div>
        <!-- div class="slack-image-block">
        <img src="https://files.topo.ai/images/slack/alert-02.png" />
        </div -->
      </div>
    }
    <!-- Microsoft Teams Header -->
    @if (showTeamsHeader) {
      <div
        class="microsoft-teams-header mb-4"
        fxLayout="row"
        fxLayoutAlign="start">
        <div>
          @if (headerDatasetName) {
            <div class="microsoft-teams-type"
              >
              <span class="microsoft-teams-dataset-type">{{ headerDatasetType }}</span>
              @if (headerDatasetType && headerDatasetName) {
                <span>|</span>
              }
              {{ headerDatasetName }}
            </div>
          }
          @if (headerDatasetName) {
            <div
              class="microsoft-teams-name"
            [innerHTML]="headerDocumentName"></div>
          }
        </div>
      </div>
    }
    <!-- WhatsApp Header -->
    @if (isWhatsApp) {
      <div
        class="mb-4">
        <div fxLayout="row"
          fxLayoutAlign="start">
          <div class="whatsapp-bubble">{{ whatsAppText }}</div>
        </div>
        <div class="whatsapp-bubble whatsapp-button">
          <div class="center">{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}</div>
        </div>
      </div>
    }
    @for (control of template?.viewControls; track control.uId; let i = $index) {
      <div>
        <div #editableElement [title]="getControlDisplay(control)"
          [draggable]="editable && canDragControl(control)"
          class="element"
          [ngClass]="{ 'editable': editable || hasEdit(control) || hasDelete(control),'hidden': isControlHidden(control), 'selected': control.uId === selectedControlUId }"
          (drop)="dropElement(i, $event)"
          (dragleave)="dragleaveElement($event)"
          (click)="onDesignElementClick(control)"
          (dblclick)="onDesignElementDblClick(control)"
          (dragstart)="dragElement($event, control)">
          @if (editable && control.uId === selectedControlUId) {
            <div
              class="drag-container"
              fxLayout="row"
              fxLayoutAlign="center center"
              title="{{ 'COMMUNICATIONS.DESIGNER.MOVE' | translate }}">
              <div style="cursor: pointer"
                (dragstart)="dragElement($event, control)">
                <i class="icon icon-drag_handle drag-handle"></i>
              </div>
            </div>
          }
          <div fxLayout="row"
            fxLayoutAlign="start center"
            topo-template-design-element
            [culture]="culture"
            [orgLanguages]="orgLanguages"
            [editMode]="false"
            [hasEdit]="hasEdit(control)"
            [editable]="editable"
            [messageSettings]="messageSettings"
            [template]="template"
            [control]="control"
            (hideControl)="onHideControl(control.uId)"
            (showControl)="onShowControl(control.uId)"
            (controlBusy)="onControlBusy(control.uId)"
            (controlReady)="onControlReady(control.uId)"
            [selected]="editable && control.uId === selectedControlUId"
            (settingsChanged)="onControlChanged(template, control, $event)"
          [index]="i"></div>
          @if (control.uId === selectedControlUId) {
            <div
              [ngClass]="{ 'tools-container': editable || hasEdit(control) || hasDelete(control) }">
              <div fxLayout="row"
                fxLayoutAlign="center center">
                @if (hasEdit(control)) {
                  <div
                    title="{{ 'COMMUNICATIONS.DESIGNER.EDIT' | translate }}"
                    class="action-button icon icon-edit"
                  (click)="onElementEditClick(control)"></div>
                }
                @if (hasDelete(control)) {
                  <div
                    title="{{ 'COMMUNICATIONS.DESIGNER.DELETE' | translate }}"
                    class="action-button icon icon-delete_trash"
                  (click)="onElementDeleteClick(control)"></div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
